module.exports = __webpack_public_path__ + "static/looking_for_a_marketing_agency_image-e58f4e5c11ef97ca60dacebfe4f44c8f.svg";